import React from 'react';
import Component from 'react-pure-render/component';
import { connect } from 'react-redux';

class ProtectedComponent extends Component {
  hasRole() {
    const { role, config } = this.props;

    const { isIntegradoKeyCloak, roles } = config || {};

    return !role || !isIntegradoKeyCloak || roles?.some(r => r.name === role);
  }

  render() {
    return this.hasRole() && <>{this.props.children}</>;
  }
}

function mapStateToProps(state) {
  return {
    config: state.config
  };
}

export default connect(mapStateToProps)(ProtectedComponent);
